import { motion } from "framer-motion";
import { EASE } from "./Reveal";

/**
 * Masked line-by-line reveal. Each line sits in an overflow-hidden mask and
 * slides up from below with a staggered delay.
 */
export const SplitLines = ({
  lines,
  as: Tag = "h1",
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  duration = 1.1,
  inView = false,
  ...rest
}) => {
  const animProps = inView
    ? { whileInView: "show", viewport: { once: true, margin: "-60px" } }
    : { animate: "show" };

  return (
    <Tag className={className} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            initial="hidden"
            {...animProps}
            variants={{
              hidden: { y: "110%", rotate: 1.5 },
              show: {
                y: "0%",
                rotate: 0,
                transition: { duration, delay: delay + i * stagger, ease: EASE },
              },
            }}
            className={`block origin-left ${
              typeof lineClassName === "function" ? lineClassName(i) : lineClassName
            }`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
